export const getNextDay = (date) => {
  const currentDate = new Date(date);
  const newDate = new Date(currentDate);

  newDate.setDate(currentDate.getDate() + 1);

  return newDate.toISOString().split("T")[0];
};
